import { ActionIcon, Tooltip } from '@mantine/core';

import DrawerLink from '../../drawerlink/DrawerLink';
import JSONEditViewer from './JSONEditViewer';

import JSONIcon from '@/assets/icons/content/json.svg';

interface JSONTriggerProps {
  json: Record<string, unknown>;
  filename?: string;
}

const JsonTrigger = ({ toggleDrawer }: { toggleDrawer: VoidFunction }) => (
  <Tooltip label="View Raw JSON">
    <ActionIcon onClick={toggleDrawer} aria-label="View Raw JSON" variant="subtle" size={35}>
      <JSONIcon />
    </ActionIcon>
  </Tooltip>
);

const JSONTrigger = ({ json, filename }: JSONTriggerProps) => (
  <DrawerLink
    id="json-viewer"
    value="View Raw JSON"
    size="xl"
    content={<JSONEditViewer json={json} filename={filename} />}
    renderButton={JsonTrigger}
  />
);

export default JSONTrigger;
